const ContentType = {
    SubCourseTopic : 1,
    Achievement : 2,
    Courses:3
};

export default ContentType;